document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a.share').forEach(element => {
    element.addEventListener('click', () => {
      navigator.clipboard.writeText(window.location)
    })
  })

  document.querySelectorAll('.print a').forEach(element => {
    element.addEventListener('click', () => {
      window.print()
    })
  })
})
